// (function () {
//   function initFilterDrawer() {
//     var drawer = document.getElementById('FilterDrawer');
//     var trigger = document.getElementById('FilterDrawerTrigger');
//     if (!drawer || !trigger) return;
//     if (drawer.dataset.filterDrawerInit === 'true') return;
//     drawer.dataset.filterDrawerInit = 'true';

//     function openDrawer() {
//       drawer.classList.add('is-open');
//       drawer.setAttribute('aria-hidden', 'false');
//       trigger.setAttribute('aria-expanded', 'true');
//       document.body.classList.add('overflow-hidden');
//       var panel = drawer.querySelector('.filter-drawer__panel');
//       if (panel) panel.focus();
//     }

//     function closeDrawer() {
//       drawer.classList.remove('is-open');
//       drawer.setAttribute('aria-hidden', 'true');
//       trigger.setAttribute('aria-expanded', 'false');
//       document.body.classList.remove('overflow-hidden');
//     }

//     trigger.addEventListener('click', openDrawer);

//     drawer.querySelectorAll('[data-filter-drawer-close]').forEach(function (el) {
//       el.addEventListener('click', closeDrawer);
//     });

//     document.addEventListener('keydown', function (event) {
//       if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
//         closeDrawer();
//       }
//     });

//     var originalCards = [];

//     function getSortCards() {
//       return Array.prototype.slice.call(
//         document.querySelectorAll('#product-grid .product_item_box, #product-grid-remaining .product_item_box')
//       );
//     }

//     function captureOriginalCards() {
//       originalCards = getSortCards();
//     }

//     function getCheckedValues(name) {
//       return Array.prototype.slice
//         .call(drawer.querySelectorAll('input[name="' + name + '"]:checked'))
//         .map(function (input) {
//           return String(input.value || '')
//             .toLowerCase()
//             .trim();
//         })
//         .filter(Boolean);
//     }

//     function normalizeNote(value) {
//       var note = String(value || '')
//         .toLowerCase()
//         .replace(/[^a-z0-9]+/g, '-')
//         .replace(/^-|-$/g, '')
//         .trim();
//       if (note === 'ambery') return 'amber';
//       return note;
//     }

//     function getCardFamilies(card) {
//       var families = [];
//       var seen = {};
//       var source = card.getAttribute('data-notes') || '';
//       var notesEl = card.querySelector('[data-notes]');
//       if (!source && notesEl) source = notesEl.getAttribute('data-notes') || '';

//       function addFamily(value) {
//         var note = normalizeNote(value);
//         if (!note || seen[note]) return;
//         seen[note] = true;
//         families.push(note);
//       }

//       source.split(',').forEach(addFamily);

//       card.querySelectorAll('.fi-card__tags .product__tag, .product__tag.font-secondary').forEach(function (el) {
//         (el.textContent || '').split(/[,|/]+/).forEach(addFamily);
//       });

//       return families;
//     }

//     function matchesOlfactory(card, selected) {
//       if (!selected.length) return true;
//       var families = getCardFamilies(card);
//       if (!families.length) return false;

//       for (var i = 0; i < selected.length; i++) {
//         var value = normalizeNote(selected[i]);
//         if (!value || families.indexOf(value) === -1) return false;
//       }
//       return true;
//     }

//     var shopForCollectionMap = null;

//     function getShopForCollectionMap() {
//       if (shopForCollectionMap) return shopForCollectionMap;
//       var el = document.getElementById('ShopForCollectionMap');
//       if (!el) {
//         shopForCollectionMap = { men: [], women: [], unisex: [] };
//         return shopForCollectionMap;
//       }
//       try {
//         shopForCollectionMap = JSON.parse(el.textContent || '{}');
//       } catch (e) {
//         shopForCollectionMap = { men: [], women: [], unisex: [] };
//       }
//       return shopForCollectionMap;
//     }

//     function normalizeShopForGender(value) {
//       var gender = String(value || '')
//         .toLowerCase()
//         .trim();
//       if (gender === 'man') gender = 'men';
//       if (gender === 'woman' || gender === 'womens') gender = 'women';
//       if (gender === 'men' || gender === 'women' || gender === 'unisex') return gender;
//       return '';
//     }

//     function productInShopForCollection(handle, gender) {
//       if (!handle || !gender) return false;
//       var normalizedHandle = String(handle).toLowerCase().trim();
//       var list = getShopForCollectionMap()[gender] || [];
//       for (var i = 0; i < list.length; i++) {
//         if (String(list[i]).toLowerCase().trim() === normalizedHandle) return true;
//       }
//       return false;
//     }

//     function getCardProductHandle(card) {
//       var product = String(card.getAttribute('data-product') || '')
//         .toLowerCase()
//         .trim();
//       if (product) return product;

//       var fiCard = card.querySelector('[data-fi-handle]');
//       if (fiCard) {
//         return String(fiCard.getAttribute('data-fi-handle') || '')
//           .toLowerCase()
//           .trim();
//       }
//       return '';
//     }

//     function getCardShopFor(card) {
//       var values = [];
//       var seen = {};

//       function addGender(value) {
//         var gender = normalizeShopForGender(value);
//         if (!gender || seen[gender]) return;
//         seen[gender] = true;
//         values.push(gender);
//       }

//       (card.getAttribute('data-shop-for') || '').split(',').forEach(addGender);

//       var inner = card.querySelector('[data-shop-for]');
//       if (inner) (inner.getAttribute('data-shop-for') || '').split(',').forEach(addGender);

//       card.querySelectorAll('.fi-card__tags .product__tag, .product__tag.font-secondary').forEach(function (el) {
//         addGender(el.textContent);
//       });

//       return values;
//     }

//     function matchesShopFor(card, selected) {
//       if (!selected.length) return true;

//       var genders = getCardShopFor(card);
//       var handle = getCardProductHandle(card);

//       for (var i = 0; i < selected.length; i++) {
//         var gender = normalizeShopForGender(selected[i]);
//         if (!gender) continue;
//         if (genders.indexOf(gender) !== -1) return true;
//         if (handle && productInShopForCollection(handle, gender)) return true;
//       }
//       return false;
//     }

//     function connectedCards(cards) {
//       return cards.filter(function (card) {
//         return card && card.isConnected;
//       });
//     }

//     function placeSortCards(cards, packAllIntoFirst) {
//       var firstGrid = document.getElementById('product-grid');
//       var remainingGrid = document.getElementById('product-grid-remaining');
//       if (!firstGrid) return;

//       var list = connectedCards(cards);
//       if (packAllIntoFirst || !remainingGrid) {
//         list.forEach(function (card) {
//           firstGrid.appendChild(card);
//         });
//         if (remainingGrid) remainingGrid.hidden = true;
//         return;
//       }

//       remainingGrid.hidden = false;
//       list.forEach(function (card, index) {
//         var parent = index < 6 ? firstGrid : remainingGrid;
//         if (parent) parent.appendChild(card);
//       });
//     }

//     function updateFilterCount(visibleCount, isFiltered) {
//       var label = 'Filter & Sort';
//       if (isFiltered) {
//         label += ' (' + visibleCount + ')';
//       }

//       var title = drawer.querySelector('.filter-drawer__title');
//       if (title) title.textContent = label;

//       var triggerEl = document.getElementById('FilterDrawerTrigger');
//       if (triggerEl) triggerEl.textContent = label;
//     }

//     function ensureGridEmptyElement() {
//       var container = document.getElementById('ProductGridContainer');
//       if (!container) return null;

//       var collection = container.querySelector('.collection:not(.collection--empty)');
//       if (!collection) return null;

//       var empty =
//         collection.querySelector('#FilterDrawerGridEmpty') || document.getElementById('FilterDrawerGridEmpty');
//       if (empty && empty.parentElement !== collection) {
//         collection.appendChild(empty);
//       }
//       return empty;
//     }

//     function updateFilterEmptyState(visibleCount, isFiltered) {
//       var showEmpty = isFiltered && visibleCount === 0;
//       var empty = ensureGridEmptyElement();
//       var firstGrid = document.getElementById('product-grid');
//       var remainingGrid = document.getElementById('product-grid-remaining');

//       if (empty) empty.hidden = !showEmpty;
//       if (firstGrid) firstGrid.hidden = showEmpty;
//       if (remainingGrid && showEmpty) remainingGrid.hidden = true;
//     }

//     function applyFilters() {
//       var olfactory = getCheckedValues('static-olfactory');
//       var shopFor = getCheckedValues('static-shop-for');
//       var cards = connectedCards(originalCards.length ? originalCards : getSortCards());
//       var visible = [];

//       cards.forEach(function (card) {
//         var show = matchesShopFor(card, shopFor) && matchesOlfactory(card, olfactory);
//         card.hidden = !show;
//         if (show) visible.push(card);
//       });

//       var giftWrap = document.getElementById('GiftWrapSection');
//       var isFiltered = olfactory.length > 0 || shopFor.length > 0;
//       if (giftWrap) {
//         giftWrap.hidden = isFiltered;
//       }

//       // Filters hide cards inside the first 6-item grid, which would leave a
//       // hole in the 3-column layout. Pack visible cards into one grid instead.
//       placeSortCards(isFiltered ? visible : cards, isFiltered);
//       updateFilterCount(visible.length, isFiltered);
//       updateFilterEmptyState(visible.length, isFiltered);

//       document.dispatchEvent(
//         new CustomEvent('shop-for-filter:changed', {
//           detail: { shopFor: shopFor }
//         })
//       );
//     }

//     function getCardPrice(card) {
//       var fiCard = card.querySelector('[data-fi-card]');
//       if (fiCard) {
//         var variantInput = fiCard.querySelector('[data-fi-variant-id]');
//         var variantsJson = fiCard.querySelector('[data-fi-variants]');
//         if (variantInput && variantsJson) {
//           try {
//             var variants = JSON.parse(variantsJson.textContent || '[]');
//             var variantId = String(variantInput.value);
//             for (var i = 0; i < variants.length; i++) {
//               if (String(variants[i].id) === variantId) {
//                 return parseInt(variants[i].price, 10) || 0;
//               }
//             }
//           } catch (e) {}
//         }
//       }
//       return parseInt(card.getAttribute('data-price'), 10) || 0;
//     }

//     function sortCardsByDisplayedPrice(direction) {
//       var cards = connectedCards(originalCards.length ? originalCards : getSortCards());
//       cards.sort(function (a, b) {
//         var priceA = getCardPrice(a);
//         var priceB = getCardPrice(b);
//         return direction === 'price-descending' ? priceB - priceA : priceA - priceB;
//       });
//       originalCards = cards;
//       placeSortCards(cards, false);
//     }

//     function applySort(sortBy) {
//       var url = new URL(window.location.href);

//       if (!sortBy) {
//         url.searchParams.delete('sort_by');
//       } else {
//         url.searchParams.set('sort_by', sortBy);
//       }

//       if (sortBy === 'price-ascending' || sortBy === 'price-descending') {
//         sortCardsByDisplayedPrice(sortBy);
//         applyFilters();
//         history.pushState({}, '', url.pathname + url.search);
//         return;
//       }

//       var grid = document.getElementById('product-grid');
//       var container = document.getElementById('ProductGridContainer');
//       var sectionId = grid && grid.getAttribute('data-id');

//       if (!container || !sectionId) {
//         window.location.href = url.pathname + url.search;
//         return;
//       }

//       var collectionEl = container.querySelector('.collection');
//       if (collectionEl) collectionEl.classList.add('loading');

//       var fetchUrl = url.pathname + '?section_id=' + encodeURIComponent(sectionId);
//       if (url.searchParams.toString()) {
//         fetchUrl += '&' + url.searchParams.toString();
//       }

//       fetch(fetchUrl)
//         .then(function (response) {
//           return response.text();
//         })
//         .then(function (html) {
//           var doc = new DOMParser().parseFromString(html, 'text/html');
//           var next = doc.getElementById('ProductGridContainer');
//           if (next) container.innerHTML = next.innerHTML;
//           history.pushState({}, '', url.pathname + url.search);
//           document.dispatchEvent(new CustomEvent('product-grid:updated'));
//         })
//         .catch(function () {
//           window.location.href = url.pathname + url.search;
//         });
//     }

//     function bindExclusiveCheckboxes(name, onChange) {
//       drawer.querySelectorAll('input[name="' + name + '"]').forEach(function (input) {
//         input.addEventListener('change', function () {
//           if (input.checked) {
//             drawer.querySelectorAll('input[name="' + name + '"]').forEach(function (other) {
//               if (other !== input) other.checked = false;
//             });
//           }
//           onChange(input);
//         });
//       });
//     }

//     bindExclusiveCheckboxes('sort_by', function (input) {
//       applySort(input.checked ? input.value : '');
//     });

//     bindExclusiveCheckboxes('static-olfactory', function () {
//       applyFilters();
//       closeDrawer();
//     });

//     bindExclusiveCheckboxes('static-shop-for', function () {
//       applyFilters();
//       closeDrawer();
//     });

//     document.addEventListener('product-grid:updated', function () {
//       captureOriginalCards();
//       applyFilters();
//     });

//     captureOriginalCards();

//     var selectedSort = drawer.querySelector('input[name="sort_by"]:checked');
//     if (selectedSort && (selectedSort.value === 'price-ascending' || selectedSort.value === 'price-descending')) {
//       sortCardsByDisplayedPrice(selectedSort.value);
//     }

//     applyFilters();
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', initFilterDrawer);
//   } else {
//     initFilterDrawer();
//   }

//   document.addEventListener('shopify:section:load', initFilterDrawer);
// })();


(function () {
  function initFilterDrawer() {
    var drawer = document.getElementById('FilterDrawer');
    var trigger = document.getElementById('FilterDrawerTrigger');
    if (!drawer || !trigger) return;
    if (drawer.dataset.filterDrawerInit === 'true') return;
    drawer.dataset.filterDrawerInit = 'true';

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('overflow-hidden');
      var panel = drawer.querySelector('.filter-drawer__panel');
      if (panel) panel.focus();
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('overflow-hidden');
    }

    trigger.addEventListener('click', openDrawer);

    drawer.querySelectorAll('[data-filter-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    var originalCards = [];

    function getSortCards() {
      return Array.prototype.slice.call(
        document.querySelectorAll('#product-grid .product_item_box, #product-grid-remaining .product_item_box')
      );
    }

    function captureOriginalCards() {
      originalCards = getSortCards();
    }

    function getCheckedValues(name) {
      return Array.prototype.slice
        .call(drawer.querySelectorAll('input[name="' + name + '"]:checked'))
        .map(function (input) {
          return String(input.value || '')
            .toLowerCase()
            .trim();
        })
        .filter(Boolean);
    }

    function normalizeNote(value) {
      var note = String(value || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '')
        .trim();
      if (note === 'ambery') return 'amber';
      return note;
    }

    function getCardFamilies(card) {
      var families = [];
      var seen = {};
      var source = card.getAttribute('data-notes') || '';
      var notesEl = card.querySelector('[data-notes]');
      if (!source && notesEl) source = notesEl.getAttribute('data-notes') || '';

      function addFamily(value) {
        var note = normalizeNote(value);
        if (!note || seen[note]) return;
        seen[note] = true;
        families.push(note);
      }

      source.split(',').forEach(addFamily);

      card.querySelectorAll('.fi-card__tags .product__tag, .product__tag.font-secondary').forEach(function (el) {
        (el.textContent || '').split(/[,|/]+/).forEach(addFamily);
      });

      return families;
    }

    function matchesOlfactory(card, selected) {
      if (!selected.length) return true;
      var families = getCardFamilies(card);
      if (!families.length) return false;

      for (var i = 0; i < selected.length; i++) {
        var value = normalizeNote(selected[i]);
        if (!value || families.indexOf(value) === -1) return false;
      }
      return true;
    }

    var shopForCollectionMap = null;

    function getShopForCollectionMap() {
      if (shopForCollectionMap) return shopForCollectionMap;
      var el = document.getElementById('ShopForCollectionMap');
      if (!el) {
        shopForCollectionMap = { men: [], women: [], unisex: [] };
        return shopForCollectionMap;
      }
      try {
        shopForCollectionMap = JSON.parse(el.textContent || '{}');
      } catch (e) {
        shopForCollectionMap = { men: [], women: [], unisex: [] };
      }
      return shopForCollectionMap;
    }

    function normalizeShopForGender(value) {
      var gender = String(value || '')
        .toLowerCase()
        .trim();
      if (gender === 'man') gender = 'men';
      if (gender === 'woman' || gender === 'womens') gender = 'women';
      if (gender === 'men' || gender === 'women' || gender === 'unisex') return gender;
      return '';
    }

    function productInShopForCollection(handle, gender) {
      if (!handle || !gender) return false;
      var normalizedHandle = String(handle).toLowerCase().trim();
      var list = getShopForCollectionMap()[gender] || [];
      for (var i = 0; i < list.length; i++) {
        if (String(list[i]).toLowerCase().trim() === normalizedHandle) return true;
      }
      return false;
    }

    function getCardProductHandle(card) {
      var product = String(card.getAttribute('data-product') || '')
        .toLowerCase()
        .trim();
      if (product) return product;

      var fiCard = card.querySelector('[data-fi-handle]');
      if (fiCard) {
        return String(fiCard.getAttribute('data-fi-handle') || '')
          .toLowerCase()
          .trim();
      }
      return '';
    }

    function getCardShopFor(card) {
      var values = [];
      var seen = {};

      function addGender(value) {
        var gender = normalizeShopForGender(value);
        if (!gender || seen[gender]) return;
        seen[gender] = true;
        values.push(gender);
      }

      (card.getAttribute('data-shop-for') || '').split(',').forEach(addGender);

      var inner = card.querySelector('[data-shop-for]');
      if (inner) (inner.getAttribute('data-shop-for') || '').split(',').forEach(addGender);

      card.querySelectorAll('.fi-card__tags .product__tag, .product__tag.font-secondary').forEach(function (el) {
        addGender(el.textContent);
      });

      return values;
    }

    function matchesShopFor(card, selected) {
      if (!selected.length) return true;

      var genders = getCardShopFor(card);
      var handle = getCardProductHandle(card);

      for (var i = 0; i < selected.length; i++) {
        var gender = normalizeShopForGender(selected[i]);
        if (!gender) continue;
        if (genders.indexOf(gender) !== -1) return true;
        if (handle && productInShopForCollection(handle, gender)) return true;
      }
      return false;
    }

    function connectedCards(cards) {
      return cards.filter(function (card) {
        return card && card.isConnected;
      });
    }

    function placeSortCards(cards, packAllIntoFirst) {
      var firstGrid = document.getElementById('product-grid');
      var remainingGrid = document.getElementById('product-grid-remaining');
      if (!firstGrid) return;

      var list = connectedCards(cards);
      if (packAllIntoFirst || !remainingGrid) {
        list.forEach(function (card) {
          firstGrid.appendChild(card);
        });
        if (remainingGrid) remainingGrid.hidden = true;
        return;
      }

      remainingGrid.hidden = false;
      list.forEach(function (card, index) {
        var parent = index < 6 ? firstGrid : remainingGrid;
        if (parent) parent.appendChild(card);
      });
    }

    function updateFilterCount(visibleCount, isFiltered) {
      var label = 'Filter & Sort';
      if (isFiltered) {
        label += ' (' + visibleCount + ')';
      }

      var title = drawer.querySelector('.filter-drawer__title');
      if (title) title.textContent = label;

      var triggerEl = document.getElementById('FilterDrawerTrigger');
      if (triggerEl) triggerEl.textContent = label;
    }

    function createGridEmptyElement(collection) {
      var empty = document.createElement('div');
      empty.id = 'FilterDrawerGridEmpty';
      empty.setAttribute('data-filter-grid-empty', '');
      empty.className = 'filter-drawer__grid-empty';
      empty.setAttribute('role', 'status');
      empty.setAttribute('aria-live', 'polite');
      empty.hidden = true;
      empty.innerHTML =
        '<p class="scent-tab filter-drawer__grid-empty-text">No product found</p>';
      collection.appendChild(empty);
      return empty;
    }

    function ensureGridEmptyElement() {
      var container = document.getElementById('ProductGridContainer');
      if (!container) return null;

      var collection = container.querySelector('.collection:not(.collection--empty)');
      if (!collection) return null;

      var empty =
        collection.querySelector('[data-filter-grid-empty]') ||
        document.getElementById('FilterDrawerGridEmpty');
      if (!empty) {
        empty = createGridEmptyElement(collection);
      } else if (empty.parentElement !== collection) {
        collection.appendChild(empty);
      }
      return empty;
    }

    function setGridEmptyVisible(empty, showEmpty) {
      if (!empty) return;
      empty.hidden = !showEmpty;
      empty.classList.toggle('filter-drawer__grid-empty--visible', showEmpty);
    }

    function updateFilterEmptyState(visibleCount, isFiltered) {
      var showEmpty = isFiltered && visibleCount === 0;
      var empty = ensureGridEmptyElement();
      var firstGrid = document.getElementById('product-grid');
      var remainingGrid = document.getElementById('product-grid-remaining');

      setGridEmptyVisible(empty, showEmpty);
      if (firstGrid) firstGrid.hidden = showEmpty;
      if (remainingGrid && showEmpty) remainingGrid.hidden = true;
    }

    function applyFilters() {
      var olfactory = getCheckedValues('static-olfactory');
      var shopFor = getCheckedValues('static-shop-for');
      var cards = connectedCards(originalCards.length ? originalCards : getSortCards());
      var visible = [];

      cards.forEach(function (card) {
        var show = matchesShopFor(card, shopFor) && matchesOlfactory(card, olfactory);
        card.hidden = !show;
        if (show) visible.push(card);
      });

      var giftWrap = document.getElementById('GiftWrapSection');
      var isFiltered = olfactory.length > 0 || shopFor.length > 0;
      if (giftWrap) {
        giftWrap.hidden = isFiltered;
      }

      // Filters hide cards inside the first 6-item grid, which would leave a
      // hole in the 3-column layout. Pack visible cards into one grid instead.
      placeSortCards(isFiltered ? visible : cards, isFiltered);
      updateFilterCount(visible.length, isFiltered);
      updateFilterEmptyState(visible.length, isFiltered);

      document.dispatchEvent(
        new CustomEvent('shop-for-filter:changed', {
          detail: { shopFor: shopFor }
        })
      );
    }

    function getCardPrice(card) {
      var fiCard = card.querySelector('[data-fi-card]');
      if (fiCard) {
        var variantInput = fiCard.querySelector('[data-fi-variant-id]');
        var variantsJson = fiCard.querySelector('[data-fi-variants]');
        if (variantInput && variantsJson) {
          try {
            var variants = JSON.parse(variantsJson.textContent || '[]');
            var variantId = String(variantInput.value);
            for (var i = 0; i < variants.length; i++) {
              if (String(variants[i].id) === variantId) {
                return parseInt(variants[i].price, 10) || 0;
              }
            }
          } catch (e) {}
        }
      }
      return parseInt(card.getAttribute('data-price'), 10) || 0;
    }

    function sortCardsByDisplayedPrice(direction) {
      var cards = connectedCards(originalCards.length ? originalCards : getSortCards());
      cards.sort(function (a, b) {
        var priceA = getCardPrice(a);
        var priceB = getCardPrice(b);
        return direction === 'price-descending' ? priceB - priceA : priceA - priceB;
      });
      originalCards = cards;
      placeSortCards(cards, false);
    }

    function applySort(sortBy) {
      var url = new URL(window.location.href);

      if (!sortBy) {
        url.searchParams.delete('sort_by');
      } else {
        url.searchParams.set('sort_by', sortBy);
      }

      if (sortBy === 'price-ascending' || sortBy === 'price-descending') {
        sortCardsByDisplayedPrice(sortBy);
        applyFilters();
        history.pushState({}, '', url.pathname + url.search);
        return;
      }

      var grid = document.getElementById('product-grid');
      var container = document.getElementById('ProductGridContainer');
      var sectionId = grid && grid.getAttribute('data-id');

      if (!container || !sectionId) {
        window.location.href = url.pathname + url.search;
        return;
      }

      var collectionEl = container.querySelector('.collection');
      if (collectionEl) collectionEl.classList.add('loading');

      var fetchUrl = url.pathname + '?section_id=' + encodeURIComponent(sectionId);
      if (url.searchParams.toString()) {
        fetchUrl += '&' + url.searchParams.toString();
      }

      fetch(fetchUrl)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.getElementById('ProductGridContainer');
          if (next) container.innerHTML = next.innerHTML;
          history.pushState({}, '', url.pathname + url.search);
          document.dispatchEvent(new CustomEvent('product-grid:updated'));
        })
        .catch(function () {
          window.location.href = url.pathname + url.search;
        });
    }

    function bindExclusiveCheckboxes(name, onChange) {
      drawer.querySelectorAll('input[name="' + name + '"]').forEach(function (input) {
        input.addEventListener('change', function () {
          if (input.checked) {
            drawer.querySelectorAll('input[name="' + name + '"]').forEach(function (other) {
              if (other !== input) other.checked = false;
            });
          }
          onChange(input);
        });
      });
    }

    bindExclusiveCheckboxes('sort_by', function (input) {
      applySort(input.checked ? input.value : '');
    });

    bindExclusiveCheckboxes('static-olfactory', function () {
      applyFilters();
      closeDrawer();
    });

    bindExclusiveCheckboxes('static-shop-for', function () {
      applyFilters();
      closeDrawer();
    });

    document.addEventListener('product-grid:updated', function () {
      captureOriginalCards();
      applyFilters();
    });

    captureOriginalCards();

    var selectedSort = drawer.querySelector('input[name="sort_by"]:checked');
    if (selectedSort && (selectedSort.value === 'price-ascending' || selectedSort.value === 'price-descending')) {
      sortCardsByDisplayedPrice(selectedSort.value);
    }

    applyFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilterDrawer);
  } else {
    initFilterDrawer();
  }

  document.addEventListener('shopify:section:load', initFilterDrawer);
})();
